define(function (require) {
    var DateTZ = require('tzdate');

    var BaseModel = require('common/models/OEBaseModel')
        , _ = require('underscore');

    return BaseModel.extend({ // Normal model attributes
        urlRoot: '/liveclassfeedbacks',
        parse: function(data) {
            if(_.isObject(data)) {

                if(data.liveClassCriteriaList) {
                    var sortedCriteriaList = {};
                    _.each(data.liveClassCriteriaList, function(criteria) {
                        if(!sortedCriteriaList[criteria.category]) {
                            sortedCriteriaList[criteria.category] = [criteria];
                        } else {
                            sortedCriteriaList[criteria.category].push(criteria);
                        }
                    });

                    data = _.extend(data, {
                        liveClassCriteriaList: sortedCriteriaList
                    });
                }

                if(data.dateOfClass) {
                    var date = new DateTZ(data.dateOfClass);
                    data = _.extend(data, {
                        dateOfClass: date.format(DateTZ.FMT.FULL_DATE+' '+DateTZ.FMT.TIME)
                    });
                }
            }

            return data;
        }
    });
});


//////////////////
// WEBPACK FOOTER
// ./js/common/models/LiveClassFeedback.js
// module id = 774
// module chunks = 26 27 28